"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGetLicenseResponse = void 0;

var _genericAsResultHeader = require("../../../../utils/generic-as-result-header");

var _modelBuilders = require("../../../../utils/model-builders");

var _license = require("../models/license");

/*
      <GetLicensesResponse xmlns="http://www.aperio.com/webservices/">
         <GetLicensesResult>
            <ASResult>0</ASResult>
            <ASMessage />
            <ASDetails />
         </GetLicensesResult>
         <Licenses>
            <SystemId>1</SystemId>
            <SystemDescription>Something Here</SystemDescription>
            <SystemName />
            <Key>CE0rc-ML1Ve-2wuXZ-WTZbK-2nVzc-30a2C-W941N-wb/id-NiPoL-pVpZq-FMmFC-WXqzG-c+PB5-pMsVU-VUQGh-A=</Key>
            <Date>2019-06-25</Date>
            <Release>12.4.0 (and greater)</Release>
            <User>chris ca</User>
            <DecodeErrorCode>0</DecodeErrorCode>
            <Components>
               <Component>
                  <Name>eSlide Manager</Name>
                  <Desc>eSlide Manager</Desc>
                  <LicenseType>Unlimited</LicenseType>
                  <NumMonthsLeft>UNLIMITED</NumMonthsLeft>
               </Component>
               <Component>
                  <Name>Reporting</Name>
                  <Desc>Reporting</Desc>
                  <LicenseType>Unlimited</LicenseType>
                  <NumMonthsLeft>UNLIMITED</NumMonthsLeft>
               </Component>
               <Component>
                  <Name>Compliance</Name>
                  <Desc>Compliance</Desc>
                  <LicenseType>Unlimited</LicenseType>
                  <NumMonthsLeft>UNLIMITED</NumMonthsLeft>
               </Component>
               <Component>
                  <Name>ExpirationWarningTime</Name>
                  <Desc>ExpirationWarningTime</Desc>
                  <LicenseType>Unlicensed</LicenseType>
                  <NumDays>30</NumDays>
               </Component>
               <Component>
                  <Name>IVD Mode</Name>
                  <Desc>IVD Mode</Desc>
                  <LicenseType>Unlimited</LicenseType>
                  <NumMonthsLeft>UNLIMITED</NumMonthsLeft>
               </Component>
            </Components>
            <AlgorithmGroups>
               <AlgorithmGroup>
                  <CurrentCount>0</CurrentCount>
                  <Name>IHC</Name>
                  <Number>2</Number>
                  <Count>10000</Count>
               </AlgorithmGroup>
               <AlgorithmGroup>
                  <CurrentCount>0</CurrentCount>
                  <Name>GenericMetered</Name>
                  <Number>4</Number>
                  <Count>10000</Count>
               </AlgorithmGroup>
               <AlgorithmGroup>
                  <CurrentCount>0</CurrentCount>
                  <Name>Unlicensed</Name>
                  <Number>5</Number>
                  <Count>-1</Count>
               </AlgorithmGroup>
            </AlgorithmGroups>
            <ImagesMax>2000</ImagesMax>
            <Algorithms />
            <ImageGraceLevel>110</ImageGraceLevel>
            <CurrentImageCount>68</CurrentImageCount>
         </Licenses>
      </GetLicensesResponse>
* */
var createGetLicenseResponse = function createGetLicenseResponse(raw) {
  return (0, _modelBuilders.parseModel)(raw, {
    result: {
      path: 'GetLicensesResult[0]',
      model: _genericAsResultHeader.genericAsResultHeader
    },
    response: {
      path: 'Licenses[0]',
      model: _license.license
    }
  });
};

exports.createGetLicenseResponse = createGetLicenseResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/security/licensing/response-parsers/get-license-response.js
// module id = 221
// module chunks = 0